import { RefObject } from 'react'
import { Chip } from '@mui/material'

interface ChipMeasureLayerProps {
  value: any
  labelKey: string
  valueKey?: string
  disabled?: boolean
  chipMeasureRef: RefObject<HTMLDivElement>
  moreMeasureRef: RefObject<HTMLSpanElement>
}

/**
 * Hidden, off-screen replica of the selected chips plus a "+N" indicator. It is
 * used purely for measurement by `useDynamicLimitTags` and never shown to users.
 */
const ChipMeasureLayer = ({
  value,
  labelKey,
  valueKey,
  disabled = false,
  chipMeasureRef,
  moreMeasureRef,
}: ChipMeasureLayerProps) => {
  const selected = Array.isArray(value) ? value : []

  return (
    <div
      ref={chipMeasureRef}
      aria-hidden='true'
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        visibility: 'hidden',
        pointerEvents: 'none',
        display: 'flex',
        width: 'max-content',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        zIndex: -1,
      }}
    >
      {selected.map((option: any, index: number) => (
        <Chip
          key={option?.key || option?._id || option?.[valueKey ?? labelKey] || index}
          label={option?.[labelKey] ?? option}
          className='MuiAutocomplete-tag'
          onDelete={() => undefined}
          disabled={option?.isDisabled ?? disabled}
        />
      ))}
      <span
        ref={moreMeasureRef}
        style={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          marginLeft: 6,
          fontSize: '0.75rem',
          alignSelf: 'center',
        }}
      >
        +{selected.length} others
      </span>
    </div>
  )
}

export default ChipMeasureLayer
